module.exports = __webpack_public_path__ + "assets/img/18_1849.97f7f276.jpg";